import React from 'react';
import { ReactComponent as Logo } from '../../assets/images/asset_logo_load.svg';
import { AnimatedLogo, SpinnerContainer } from './loadingSpinner.styles';

export const LoadingSpinner: React.FC = () => {
  return (
    <SpinnerContainer>
      <AnimatedLogo>
        <Logo />
      </AnimatedLogo>
    </SpinnerContainer>
  );
};
